export const environment = {
  production: false,
  // apiUri: "http://localhost:44387",
  // apiUri: "https://api-test.camillo.vn",
  apiUri: "https://api.camillo.vn",
  firebase: {
    apiKey: "AIzaSyC4woOQlG_f9SU2SSRQckGZCE_oZkcrRXQ",
    authDomain: "duongpham-4d483.firebaseapp.com",
    projectId: "duongpham-4d483",
    storageBucket: "duongpham-4d483.firebasestorage.app",
    messagingSenderId: "153959628686",
    appId: "1:153959628686:web:720c1ad6e5b154b6856edf",
    vapidKey: "BCOEkGAdopmnRdUs-faWR9wNSGp06ZxRkV7p5jRYIaGKAj_2Qwzss-MLbwBpgbYgVVZmmTgK-EY1SsBU4ZI_h1M"
  },
  capchaSecret: "6Le4t2EsAAAAACrzffQ2wpdr5fXAO0KfbdarOT4q",
};
